import { AxiosResponse } from 'axios';
import { RestServiceConnection } from '../restServiceConnection';

const ENDPOINT = '/route';

export class RouteService extends RestServiceConnection {

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES CREAR UNA NUEVA RUTA
     * @EN CREATES A NEW ROUTE
     */
    // -------------------------------------------------------------------------------------------------------------
    createRoute = async (route: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/create',
            data: route,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------


    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES EDITA UNA RUTA EXISTENTE
     * @EN EDITS AN EXISTING ROUTE
     */
    // -------------------------------------------------------------------------------------------------------------
    editRoute = async (route: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/edit',
            data: route,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------


    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE UNA LISTA DE RUTAS
     * @EN GETS A LIST OF ROUTES
     */
    // -------------------------------------------------------------------------------------------------------------
    list = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list',
            data: filters,
            headers: {
                "Content-Type": "application/json"
            }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------


    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE UNA RUTA POR ID
     * @EN GETS A ROUTE BY ID
     */
    // -------------------------------------------------------------------------------------------------------------
    getRouteById = async (routeId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/get',
            data: { id: routeId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------


    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES ACTIVA O DESACTIVA UNA RUTA
     * @EN ACTIVATES OR DEACTIVATES A ROUTE
     */
    // -------------------------------------------------------------------------------------------------------------
    toggleStatus = async (routeId: string, active: boolean) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/toggle',
            data: { id: routeId, active },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------


    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES BORRA UNA RUTA
     * @EN DELETES A ROUTE
     */
    // -------------------------------------------------------------------------------------------------------------
    delete = async (route: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/delete',
            data: { id: route }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------


    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES BORRA VARIAS RUTAS
     * @EN DELETES MULTIPLE ROUTES
     */
    // -------------------------------------------------------------------------------------------------------------
    multiDelete = async (routeIds: string[]) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/delete-multi',
            data: { ids: routeIds }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------


    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES AÑADE UNA SUCURSAL A UNA RUTA
     * @EN ADDS A HEADQUARTER TO A ROUTE
     */
    // -------------------------------------------------------------------------------------------------------------
    addHeadquarterToRoute = async (routeId: string, headquarterId: string, orderIndex?: number) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/add-headquarter',
            data: { routeId, headquarterId, orderIndex },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------


    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES QUITA UNA SUCURSAL DE UNA RUTA
     * @EN REMOVES A HEADQUARTER FROM A ROUTE
     */
    // -------------------------------------------------------------------------------------------------------------
    removeHeadquarterFromRoute = async (routeHeadquarterId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/remove-headquarter',
            data: { id: routeHeadquarterId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------


    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES ACTUALIZA LA POSICIÓN DE UNA SUCURSAL EN UNA RUTA
     * @EN UPDATES THE POSITION OF A HEADQUARTER IN A ROUTE
     */
    // -------------------------------------------------------------------------------------------------------------
    updateHeadquarterPosition = async (routeId: string, headquarterId: string, orderIndex: number) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/update-headquarter-position',
            data: { routeId, headquarterId, orderIndex },
            headers: { "Content-Type": "application/x-www-form-urlencoded" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------


    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE LAS SUCURSALES ASOCIADAS A UNA RUTA
     * @EN GETS THE HEADQUARTERS ASSOCIATED WITH A ROUTE
     */
    // -------------------------------------------------------------------------------------------------------------
    getRouteHeadquarters = async (routeId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/headquarters',
            data: { routeId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------


    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE UNA LISTA PAGINADA DE RELACIONES RUTA-SEDE
     * @EN GETS A PAGINATED LIST OF ROUTE-HEADQUARTERS RELATIONSHIPS
     */
    // -------------------------------------------------------------------------------------------------------------
    listRouteHeadquarters = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list-headquarters',
            data: filters,
            headers: {
                "Content-Type": "application/json"
            }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------


    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE UNA LISTA DE RUTAS PARA SELECT
     * @EN GETS A LIST OF ROUTES FOR SELECT
     */
    // -------------------------------------------------------------------------------------------------------------
    listForSelect = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: ENDPOINT + '/list-select',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES CLONA UNA RUTA
     * @EN CLONES A ROUTE
     */
    // -------------------------------------------------------------------------------------------------------------
    clone = async (id: string, name?: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/clone',
            data: { id, name },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

}